"use strict";

exports.__esModule = true;
exports.getUnitTypes = void 0;
var getUnitTypes = exports.getUnitTypes = function getUnitTypes(translate) {
  return [{
    value: "seconds",
    displayName: translate("EnrichEditorUI.UnitType.seconds", "seconds")
  }, {
    value: "minutes",
    displayName: translate("EnrichEditorUI.UnitType.seconds", "minutes")
  }, {
    value: "hours",
    displayName: translate("EnrichEditorUI.UnitType.seconds", "hours")
  }];
};